import { DownOutlined, FormOutlined } from "@ant-design/icons";
import { Dropdown, Form, Input, Menu, Space, Typography } from "antd";
import Table, { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import React, { useEffect, useState } from "react";
import "./style.scss";
// import { DataModule } from "types";
import { AddNewsModal, EditNewsModal } from "components";
import { api } from "services/api";

export const ManageNews: React.FC = () => {
	const [selectedValue, setSelecteValue] = useState<string>("10");
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isOpenEdit, setIsOpenEdit] = useState<boolean>(false);
	const [currentImgURL, setCurrentImgURL] = useState<string>("");
	const [newsStatus, setNewsStatus] = useState<boolean>(false);
	const [newsIsHighlight, setNewsIsHighlight] = useState<boolean>(false);
	const [currentNewsInfo, setCurrentNewsInfo] = useState<any[]>([]);
	const [paginationInfo, setPaginationInfo] = useState<TablePaginationConfig>();
	const [totalItensValue, setTotalItensValue] = useState<number>(0);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [news, setNews] = useState<any[]>();
	const [form] = Form.useForm();
	const [editForm] = Form.useForm();

	const menu = (
		<Menu
			selectable
			// @ts-ignore
			onClick={(e) => setSelecteValue(e.key)}
			defaultSelectedKeys={["3"]}
			items={[
				{
					key: "10",
					label: "10",
				},
				{
					key: "20",
					label: "20",
				},
				{
					key: "30",
					label: "30",
				},
				{
					key: "40",
					label: "40",
				},
			]}
		/>
	);

	const getUpdatedInfo = async (id: string) => {
		setIsLoading(true);
		if (news) {
			const {
				data: {
					data: { news },
				},
			} = await api.get(`/news/${id}`);
			setIsLoading(false);

			setCurrentNewsInfo(news);
		}
	};

	const columns: ColumnsType<any> = [
		{
			title: "Título da notícia",
			dataIndex: "title",
			key: "title",
			render: (text) => <p style={{ margin: 0 }}>{text}</p>,
			onCell: () => {
				return {
					width: "12%",
				};
			},
		},
		{
			title: "Descrição",
			dataIndex: "description",
			key: "description",
		},
		{
			title: "Cadastrado em",
			dataIndex: "created_at",
			key: "created_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "11%",
				};
			},
		},
		{
			title: "Última edição",
			dataIndex: "updated_at",
			key: "updated_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "11%",
				};
			},
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (status) => (
				<p style={{ margin: 0 }}>
					{status === "publish" ? "Publicado" : "Desativado"}
				</p>
			),
		},
		{
			title: "Ativo",
			dataIndex: "is_active",
			key: "is_active",
			render: (active) => (
				<p style={{ margin: 0 }}>{active === true ? "Sim" : "Não"}</p>
			),
		},
		{
			title: "",
			key: "",
			render: (_, record) => (
				<Space size="middle">
					<FormOutlined
						className="edit"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenEdit(true);
						}}
					/>
				</Space>
			),
		},
	];

	useEffect(() => {
		setNews(undefined);
		api
			.get(
				`/news?per_page=${selectedValue}&paginate=true&page=${
					paginationInfo?.current ? paginationInfo.current : 1
				}`
			)
			.then((res) => {
				setTotalItensValue(Number(res?.data?.pagination?.total));
				setNews(res.data.data.news);
			});
	}, [selectedValue, paginationInfo]);

	return (
		<div className="m-news">
			<AddNewsModal
				form={form}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				newsStatus={newsStatus}
				setNewsStatus={setNewsStatus}
				newsIsHighlight={newsIsHighlight}
				setNewsIsHighlight={setNewsIsHighlight}
				setNews={setNews}
			/>
			<EditNewsModal
				form={editForm}
				isOpen={isOpenEdit}
				setIsOpen={setIsOpenEdit}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				newsStatus={newsStatus}
				setNewsStatus={setNewsStatus}
				newsIsHighlight={newsIsHighlight}
				setNewsIsHighlight={setNewsIsHighlight}
				currentNewsInfo={currentNewsInfo}
				setNews={setNews}
			/>
			<div className="m-news__container">
				<h1 className="m-news__container__title">Notícias</h1>
				<div className="m-news__container__input">
					<div className="m-news__container__input__user-number">
						Exibir{" "}
						{
							<Dropdown overlay={menu}>
								<Typography.Text>
									{selectedValue}
									<DownOutlined style={{ marginLeft: "5px" }} />
								</Typography.Text>
							</Dropdown>
						}{" "}
						notícias
					</div>
					<Input placeholder="Pesquisar..." />
					<button
						className="m-news__container__input__btn"
						onClick={() => setIsOpen(true)}
					>
						+ Adicionar Notícia
					</button>
				</div>
				<Table
					loading={news === undefined || isLoading}
					columns={columns}
					dataSource={news}
					onChange={(e) => setPaginationInfo(e)}
					pagination={{
						total: totalItensValue,
						showSizeChanger: false,
						pageSize: +selectedValue,
					}}
				/>
			</div>
		</div>
	);
};
